import { render, staticRenderFns } from "./qrcode-drink-label.vue?vue&type=template&id=cb336f92&scoped=true&"
import script from "./qrcode-drink-label.vue?vue&type=script&lang=js&"
export * from "./qrcode-drink-label.vue?vue&type=script&lang=js&"
import style0 from "./qrcode-drink-label.vue?vue&type=style&index=0&id=cb336f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb336f92",
  null
  
)

export default component.exports